export default "__VITE_ASSET__Dz5PLp1D__"